import React from 'react'

// types
import { FormItemProps } from './types'

// components
import InputLabel from '../InputLabel/InputLabel'
import InputError from '../InputError/InputError'

// styles
import * as SC from './FormItemStyles'

const FormItem = (props: FormItemProps) => {
	const { children, required, htmlFor, label, labelScreenReaderOnly, asFieldset, legendId, error } = props

	let labelNode: React.ReactNode = null
	if (label) {
		if (asFieldset) {
			labelNode = (
				<SC.FormFieldLegend id={legendId} $required={required} $screenReaderOnly={labelScreenReaderOnly}>
					{label}
				</SC.FormFieldLegend>
			)
		} else {
			labelNode = (
				<InputLabel required={required} htmlFor={htmlFor} screenReaderOnly={labelScreenReaderOnly}>
					{label}
				</InputLabel>
			)
		}
	}

	const content = (
		<>
			{labelNode}
			{children}
			{error && <InputError htmlFor={asFieldset ? undefined : htmlFor}>{error}</InputError>}
		</>
	)

	if (asFieldset) {
		return <SC.FormFieldset>{content}</SC.FormFieldset>
	}

	return <SC.FormFieldWrapper>{content}</SC.FormFieldWrapper>
}

export default FormItem
